(function () {
	var TSGUtils = {
		/** 
		* The return value when we should not parse a number range from the page select textbox..
		* @default
		*/
		DO_NOT_PARSE : "invalid",
		/** 
		* The return value when we could not parse a number range from the page select textbox..
		* @default
		*/
		CAN_NOT_PARSE : "cannot parse", //failed the regex match check to go into seperatePageRanges
		/** 
		* The return value when the parsed page select textbox results in an empty range
		* @default
		*/
		EMPTY_PAGE_RANGE : "empty page range", //after regex we landed with an empty page range
		/**
		 * Constants for file size label abbreviations
		 */
		FILE_SIZE_ABBREVIATIONS : {
			KILOBYTE : "KB",
			MEGABYTE : "MB",
			GIGABYTE : "GB"
		}
	};

	/**
	 * Constants for file size conversions
	 */
	TSGUtils.FILE_SIZE_CONVERSIONS = {};
	/**
	 * The number of bytes in a KB
	 */
	TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_KILOBYTE = 1024;
	/**
	 * The number of bytes in a MB
	 */
	TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_MEGABYTE = TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_KILOBYTE * 1024;
	/**
	 * The number of bytes in a GB
	 */
	TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_GIGABYTE = TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_MEGABYTE * 1024;

	// the global-scope this is NOT the global object in Node.js
	var globalScope = (typeof global !== 'undefined' && (typeof window === 'undefined' || window === global.window)) ? global : this;

	// check for nodeJS
	var hasModule = (typeof module !== 'undefined' && module && module.exports);

	/**
	 * For Testing purposed only. This method is called from the spec 
	 * file to set up any modules needed for testing that dont get pulled in
	 * automatically by tsgUtils. 
	 * @param {Object} options - object containing any mock modules we want to set on any other modules
	 */
	TSGUtils.setupVariablesForTesting = function(options) {
		_ = require('underscore');
		Backbone = require('backbone');
		window = options.window;
	};
	
	/**
	 * If enabled in /admin, sterilize the filenames that are uploaded. 
	 * @param {string} filename - The original filename that was uploaded
	 * @param {Object} attributes - The json array of configs set in /admin.
	 * @returns The sterilized filename 
	 */
	TSGUtils.sterilizeFilename = function(filename, attributes) {
		if (attributes.shouldSterilizeFilenames === 'true' && filename) {
			return filename.replace(new RegExp(attributes.regexToSterilizeFilenamesWith, "g"), attributes.sterilizeReplacementString);
		}
		return filename;
	};

	/**
	 * Formats the pages whether they are a range of numbers, etc
	 * @global
	 * @param the pages that need to be formatted
	 */
	TSGUtils.getFormattedSelectedPages = function(pagesSelected) {
		var sortedPages = pagesSelected;
		
		var selectedPages = [];
		var prevPage = sortedPages[0];
		var range = false;
		var lastIndex = 0;

		_.each(sortedPages, function(currentPage, index) {
			var rangeIndex;
			var nextPage = sortedPages[index + 1] || -1; 
			if(selectedPages[lastIndex]) {
				rangeIndex = selectedPages[lastIndex].indexOf('-');
			}
			else {
				rangeIndex = -1;
			}
			//the first page is automatically pushed onto the new array
			if(index === 0) {
				selectedPages.push('' + currentPage);
				if(currentPage === (nextPage - 1)) {
					lastIndex = 0;
				}
				else {
					lastIndex = 1;
				}
			}
			else {
				//if the currentpage is in sequential order between the page before and after it
				//and a range hasn't been started we need to add a '-' 
				if((prevPage + 1) === currentPage && currentPage === (nextPage - 1)) {
					if(!range) {
						if(lastIndex < (selectedPages.length - 1)){
							lastIndex ++;
						} 
						selectedPages[lastIndex] = '' + selectedPages[lastIndex] + '-';
					}
					range = true;
				}
				//if it is in the range but the next page isn't in the range add the currentPage number to end the range
				else if ((prevPage + 1) === currentPage && rangeIndex !== -1) {
					range = false;
					selectedPages[lastIndex] = '' + selectedPages[lastIndex] + currentPage;
					lastIndex ++;
					
				}
				//if the currentPage is in sequential order to the page previous but there is no range, push it onto the array
				//on it's own
				else if ((prevPage + 1) === currentPage && rangeIndex === -1) {
					selectedPages.push('' + currentPage);
					lastIndex ++;
				}
				//if the currentPage is not part of a range or will not be because the next page 
				//isn't right after it, push it on the array separately.
				else if ((prevPage + 1) !== currentPage && currentPage !== (nextPage - 1)) {
					selectedPages.push('' + currentPage);
					lastIndex ++;
				}
				//push the currentPage on without increasing the index because it may be the start of a new range
				else if (nextPage > currentPage) {
					selectedPages.push('' + currentPage);
				}
			}
			prevPage = currentPage;
		}, this);

		return selectedPages;
	};

   /**
	 * Takes in the passed in pages and parses the dahses and puts the 
	 * numbers in sequential order and then returns the values or calls the 
	 * passed in function. 
	 * @param {string} pages - the pages that need to be parsed.
	 * @param {function} callback - the function to call when finished parsing the pages
	 * @returns {array} sortedPages - an array of the page numbers in sequential order
	 *	  If the passed in pages is blank, then returns the TSGUtils.EMPTY_PAGE_RANGE constant
	 *	  If it could not properly parse the page range then it returns the TSGUtils.CAN_NOT_PARSE constant
	 */

	TSGUtils.parsePageRange = function(pages, callback) {
		//Remove all the extra whitespaces and unnecessary characters in the string.
		pages = pages.replace(/\D*,\D*/g, ",");
		pages = pages.replace(/\D*-\D*/g, "-");
		pages = pages.replace(/-+/g, "-"); 
		pages = pages.replace(/(^[,\s]+)|([,\s]+$)/g, ''); // remove all leading and trailing commas and whitespace
		pages = pages.replace(/(^-)|(-$)/g, ""); // remove remaining leading and trailing dashes 
		
		// blank strings shouldn't fall into the main parsing block, they're just an empty page range
		if (!pages) {
			 if (_.isFunction(callback)) {
				callback(TSGUtils.EMPTY_PAGE_RANGE);
				return;
			}else {
				return TSGUtils.EMPTY_PAGE_RANGE;
			}
		} else if(pages.match(/\d$/g)) {

			//if the string ends with a number, we stand a chance of a parsing it into a valid page range
			pages = TSGUtils.seperateRanges(pages);
			if(pages !== TSGUtils.DO_NOT_PARSE) {
				pages = pages.replace(/[\D,-]+/g, ",");
				//Turn the string into an array.
				pages = pages.split(',');
				
				//Remove any duplicate numbers.
				pages = _.uniq(pages);
				//Sort the pages so they are in sequential order.
				var sortedPages = _.sortBy(pages.map(Number), function(num) {
					return num;
				});

				if(_.isFunction(callback)){
					callback(sortedPages);
					return; // prevent the callback from being called twice
				}else {
					return sortedPages;
				}
			}
		}

		if(_.isFunction(callback)) {  
			callback(TSGUtils.CAN_NOT_PARSE);
		}else {
			return TSGUtils.CAN_NOT_PARSE;
		}
	};

	/**
	 * Parses each range into a list of numbers
	 * @param {string} pages - pages that are in the text area.
	 * @returns {string} pages - a comma seperated list of all the pages in the range
	 *	  If the passed in string can't be parsed, the TSGUtils.DO_NOT_PARSE constant is returned
	 */
	TSGUtils.seperateRanges = function(pages) {
		//If there are '-'s in the string, we need to make sure
		//we break them apart and get the correct numbers.
		if(pages.match(/-+/g)) {
			var ranges;
			var lastDashRange = /(\d+)-(\d*)$/g.exec(pages);
			ranges = pages.match(/\d+-\d*/g);
			var rangeNumberList;
			var dashRange;
			//For each range in the string get the list of numbers and replace
			//the '-' with the correct page numbers.
			_.each(ranges, function(range) { 
				if(lastDashRange) {
					if(range === lastDashRange[0]) {
						//If the last range in the string doesn't end in a number, we do not want to do anything.
						if(lastDashRange[2].match(/\d/g)) {
							//If the last number in the range is less than the first number, we do not want to do anything.
							if(parseInt(lastDashRange[2]) <= parseInt(lastDashRange[1])) {
								pages = TSGUtils.DO_NOT_PARSE;
								return pages; 
							}
						}
						else {
							pages = TSGUtils.DO_NOT_PARSE;
							return pages; 
						}
					}
				}

				dashRange = /(\d+)-(\d*)/g.exec(range);

				rangeNumberList = _.range(parseInt(dashRange[1]), parseInt(dashRange[2])+1);
				//Replace the range with the sequence of numbers so all of the pages will be highlighted.
				pages = pages.replace(dashRange[1] + "-" + dashRange[2], rangeNumberList.toString());			 
			});
		}
		return pages;
	};

	/**
	 * Returns the navigator off the window
	 * @returns {string} navigator 
	 */
	TSGUtils.getNavigator = function(){
		return window.navigator;
	};

	/**
	 * Helper method that will get us the browser version the current user is utilizing. 
	 * code found online to get the browser name and version: http://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser
	 * @returns {Object} - object containing name and version of the browser
	 */
	TSGUtils._getBrowser = function(){
		var ua=TSGUtils.getNavigator().userAgent,tem,M =ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if(/trident/i.test(M[1])){
			tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
			return {name:'MSIE',version:(tem[1]||'')};
		}
		if(M[1]=== 'Chrome'){
			tem=ua.match(/\b(OPR|Edge)\/(\d+)/);
			if(tem!==null)return {name:tem[1].replace('OPR', 'Opera'),version:tem[2]};
		}
		M = M[2]? [M[1], M[2]]: [TSGUtils.getNavigator().appName, TSGUtils.getNavigator().appVersion, '-?'];
		if((tem=ua.match(/version\/(\d+)/i))!==null) {M.splice(1,1,tem[1]);}
		return {
		  name: M[0],
		  version: M[1]
		};
	};

	/**
	 * Sends the parameters of a performance log to OC
	 * @param {Object} options - object containing the log data, ticket info, and callback functions for the performace log OC call
	 */
	TSGUtils.sendPerformanceLog = function (options) {
		var url = options.requestUrl + "/metrics/createPerformanceLog";
		if (options.ticket) {
			url = url.concat("?ticket=" + options.ticket);
		}

		Backbone.ajax({
			url: url,
			data: JSON.stringify(options.data),
			type: "POST",
			contentType: "application/json",
			global: false,
			success: options.successCallback,
			error: options.errorCallback
		});
	};

	/**
	 * Converts a file size from bytes to KB
	 * @param {int} fileSize - size of file in bytes
	 * @returns {float} - the file size converted to kilobytes
	 */
	TSGUtils.getFileSizeAsKilobytes = function(fileSize) {
		return fileSize / TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_KILOBYTE;
	};

	/**
	 * Converts a file size from bytes to MB
	 * @param {int} fileSize - size of file in bytes
	 * @returns {float} - the file size converted to megabytes
	 */
	TSGUtils.getFileSizeAsMegabytes = function(fileSize) {
		return fileSize / TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_MEGABYTE;
	};

	/**
	 * Converts a file size from bytes to GB
	 * @param {int} fileSize - size of file in bytes
	 * @returns {float} - the file size converted to gigabytes
	 */
	TSGUtils.getFileSizeAsGigabytes = function(fileSize) {
		return fileSize / TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_GIGABYTE;
	};

	/**
	 * gets the uri without the origin or app root
	 * @param {int} rootLength - length of the application root
	 * @returns {String} - returns a String representing the url without the origin or application root
	 */
	TSGUtils.getUrlForUri = function(rootLength) {
		var url = window.location.href.replace(window.location.origin, "").substring(rootLength);
		//if the application always get inputs correctly, we wouldn't need this, but this is protecting us against
		//people configuring the app wrong (URI needs a leading slash)
		if (url[0] !== "/") {
		  url = "/" + url;
		}

		return url;
	};

	/**
	 * Fetches ocos for the list of objectIds
	 * @param {Array} objectIds - array of objectIds 
	 * @param {String} clientRequestUrl - the base url to make the request from
	 * @param {Object} deferred - jquery deferred that will get resolved when call completes
	 */
	TSGUtils.fetchOcos = function(objectIds, baseUrl, deferred){
		Backbone.ajax({
			url: baseUrl + '/openContentObjects',
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify(objectIds),
			global: false,
			success: function(objects) {
				deferred.resolve(objects);
			},
			error: function() {
				deferred.reject([]);
			}
		});
		return deferred.promise();
	};

	/************************************
		Exposing TSGUtils
	************************************/

	function makeGlobal() {
		globalScope.TSGUtils = TSGUtils;
	}

	// CommonJS module is defined
	if (hasModule) {
		module.exports = TSGUtils;
	}else if (typeof define === 'function' && define.amd) {
		define('tsgUtils',['require','exports','module'],function (require, exports, module) {
			return TSGUtils;
		});
	} else {
		makeGlobal();
	}
}).call(this);

